import axios from '../axios.js';

var api = {
  //练习册试卷列表
  getPraList(params){
    return axios.post('index/exercise/index',params)
  }
}

export default api



// WEBPACK FOOTER //
// ./src/api/practice.js